import { Box, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useNotify, useRedirect } from 'react-admin';

const useStyles = makeStyles({
  actions: {
    marginTop: '48px',
    display: 'flex',
    gap: '16px',
    justifyContent: 'flex-end',
  },
  button: {
    fontWeight: 500,
    lineHeight: '19px',
    fontSize: '14px',
    padding: '8px 43px',
    borderRadius: '500px',
    textTransform: 'capitalize',
    minWidth: '170px',
  },
  buttonWhite: {
    fontWeight: 500,
    lineHeight: '19px',
    fontSize: '14px',
    padding: '8px 43px',
    borderRadius: '500px',
    background: 'white',
    textTransform: 'capitalize',
    minWidth: '170px',
  },
});

export const Actions = ({
  step,
  setStep,
  lastStep,
  handleLastStep,
  validations,
  watch,
  setError,
  clearErrors,
}) => {
  const classes = useStyles();
  const values = watch(); //Problem watch subscrible to all fields?
  const notify = useNotify();
  const redirect = useRedirect();

  function traverseAndSetErrors(obj, path = '') {
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        let value = obj[key];
        let newPath = path ? `${path}.${key}` : key;

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            traverseAndSetErrors(item, `${newPath}[${index}]`);
          });
        } else if (typeof value === 'object' && value !== null) {
          traverseAndSetErrors(value, newPath);
        } else {
          setError(`${newPath}`, { message: `${value}` });
        }
      }
    }
  }

  const handleNext = async () => {
    if (step != lastStep) {
      clearErrors();
      const currentErrors = await validations[step](values);
      if (Object.keys(currentErrors).length > 0) {
        traverseAndSetErrors(currentErrors);
        // trigger(Object.keys(currentErrors));
        notify('Por favor corrija los errores antes de continuar', {
          type: 'error',
        });
        return;
      }

      setStep(prev => prev + 1);
    }
    if (lastStep == step && handleLastStep) {
      clearErrors();
      const currentErrors = await validations[step](values);
      if (Object.keys(currentErrors).length > 0) {
        traverseAndSetErrors(currentErrors);
        // trigger(Object.keys(currentErrors));
        notify('Por favor corrija los errores antes de continuar', {
          type: 'warning',
        });
        return;
      } else {
        const resp = await handleLastStep(values);
        if (resp) {
          setStep(prev => prev + 1);
        }
      }
    }
  };

  const handlePrev = () => {
    if (step != 1) {
      setStep(prev => prev - 1);
    }
    if (step == 1) {
      redirect('/goals');
    }
  };
  if (step > lastStep) return null;
  return (
    <Box className={classes.actions}>
      <Button
        variant="outlined"
        onClick={() => handlePrev()}
        className={classes.buttonWhite}
      >
        {step == 1 ? 'Cancelar' : 'Anterior'}
      </Button>
      <Button
        variant="contained"
        onClick={() => handleNext()}
        className={classes.button}
      >
        {step == lastStep ? 'Finalizar' : 'Siguiente'}
      </Button>
    </Box>
  );
};
